export const signUpConstants = {
  SIGN_UP_USER: 'SIGN_UP_USER',
  RESEND_CONFIRMATION: 'RESEND_CONFIRMATION',
};
